module.exports = __webpack_public_path__ + "img/social-sciences.47b02e59.svg";